import { API_BASE_BLOCKCHAIN_URL, API_BASE_API_SSO_URL } from '../urls';

export const API_BASE_URL = `${API_BASE_BLOCKCHAIN_URL}/api`;
export const API_ADMIN_URL = `${API_BASE_API_SSO_URL}/tt-block-chain/admin`;
